if (typeof hs != 'undefined') {
	hs.graphicsDir = '/assets/highslide/graphics/';
	hs.showCredits = false;


	// French language strings
	hs.lang = {
		cssDirection: 'ltr',
		loadingText: 'Chargement...',
		loadingTitle: 'Cliquer pour annuler',
		focusTitle: 'Cliquer pour amener au premier plan',
		fullExpandTitle: 'Afficher à la taille réelle',
		creditsText: 'Propulsé par <i>Highslide JS</i>',
		creditsTitle: 'Site Web de Highslide JS',
		previousText: 'Précédente',
		nextText: 'Suivante',
		moveText: 'Déplacer',
		closeText: 'Fermer',
		closeTitle: 'Fermer (esc ou Échappement)',
		resizeTitle: 'Redimensionner',
		playText: 'Lancer',
		playTitle: 'Lancer le diaporama (barre d\'espace)',
		pauseText: 'Pause',
		pauseTitle: 'Suspendre le diaporama (barre d\'espace)',
		previousTitle: 'Précédente (flèche gauche)',
		nextTitle: 'Suivante (flèche droite)',
		moveTitle: 'Déplacer',
		fullExpandText: 'Taille réelle',
		//number: 'Image %1 sur %2',
		number: '%1/%2',
		restoreTitle: 'Cliquer pour fermer l\'image, cliquer et faire glisser pour déplacer, utiliser les touches flèches droite et gauche pour suivant et précédent.'
	};

	hs.registerOverlay({
		html: '<div class="closebutton" onclick="return hs.close(this)" title="Fermer"></div>',
		position: 'top right',
		useOnHtml: true,
		fade: 2 // fading the semi-transparent overlay looks bad in IE
	});
}

jQuery(function($) {
	$('.highslide-galery').each(function () {
		const contentInfo = $(this).data('content-info');
		//Add the controlbar
		hs.addSlideshow({
			slideshowGroup:  $(this).data('contentinfo'),
			interval: 1,
			repeat: false,
			useControls: true,
			fixedControls: 'fit',
			overlayOptions: {
				opacity: 0.75,
				position: 'bottom center',
				hideOnMouseOut: true
			}
		});
	});
});